export { navigationMenu } from "./navigation-markup";

export const wireNavigationMenu = (): void => {
  const root = document.querySelector<HTMLElement>("[data-site-menu]");
  const trigger = root?.querySelector<HTMLButtonElement>(".menu-trigger");
  const panel = root?.querySelector<HTMLElement>(".menu-panel");
  if (!root || !trigger || !panel) return;

  const close = (): void => {
    panel.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
  };
  trigger.addEventListener("click", () => {
    const opening = panel.hidden;
    panel.hidden = !opening;
    trigger.setAttribute("aria-expanded", String(opening));
  });

  const adminTrigger = root.querySelector<HTMLButtonElement>(".admin-menu-trigger");
  const adminPanel = root.querySelector<HTMLElement>(".admin-menu-panel");
  adminTrigger?.addEventListener("click", () => {
    if (!adminPanel) return;
    const opening = adminPanel.hidden;
    adminPanel.hidden = !opening;
    adminTrigger.setAttribute("aria-expanded", String(opening));
  });

  document.addEventListener("click", (event) => {
    if (!root.contains(event.target as Node)) close();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      close();
      trigger.focus();
    }
  });
};
